import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    videoPlayerClassName,
    boxClassName,
} from '@archipro-design/aria';
import { MODAL_BOX_SHADOW } from '@modules/page-builder/component/common/pagebuilder.style';
import type { ColumnDimensionType } from '@modules/page-builder/types';

export const AspectRatioBox: StyleRule<{ dimension: ColumnDimensionType }> = ({
    theme,
    dimension,
}) => ({
    position: 'relative',
    width: '100%',
    paddingTop: `${(dimension.mobileHeight / dimension.mobileWidth) * 100}%`,

    [theme.screen.tablet]: {
        paddingTop: `${
            (dimension.tabletHeight / dimension.tabletWidth) * 100
        }%`,
    },

    [theme.screen.laptop]: {
        paddingTop: `${(dimension.height / dimension.width) * 100}%`,
    },

    [`& .${videoPlayerClassName}`]: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',

        [`& .${boxClassName}`]: {
            position: 'absolute',
        },
    },
});

export const HoverActions: StyleRule = ({ theme }) => ({
    position: 'absolute',
    margin: pxToRem(16),
    top: 0,
    right: 0,
    display: 'flex',
    opacity: 0,
    visibility: 'hidden',
    boxShadow: MODAL_BOX_SHADOW,
    zIndex: theme.siteVariables.zIndexes.foreground,
});
